import FlashResultsDetailedScoreItem from "../../../items/courses/flash/FlashResultsDetailedScoreItem";

export default function ExerciserResultsDetailedScores({good, bad}) {
    // Used in ResultsSummary to display detailed score
    // by answer type list

    // BUILD
    return (
        <div className="grow sm:grow-0 h-full flex flex-col justify-center space-y-[24px]">
            <FlashResultsDetailedScoreItem isGoodScore={true}
                                           color={"bg-primaryDark1"}
                                           score={good}
                                           label={good > 1 ? "Bonnes réponses" : "Bonne réponse"} />
            <FlashResultsDetailedScoreItem isGoodScore={false}
                                           color={"bg-secondary"}
                                           score={bad}
                                           label={bad > 1 ? "Erreurs" : "Erreur"} />
        </div>
    );
}